import React from 'react'
import ReactImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css"
import slider1 from "./../../images/slider1.png"
import RightArrow from './RightArrow'
import LeftArrow from './LeftArrow'
import UseViewProductDetails from '../../CustomHooks/Products/UseViewProductDetails';

const ProductGallery = () => {
  const [item, images, categoryName, BrandName, similarProducts,rateValue] = UseViewProductDetails()
  return (
    <>
      <ReactImageGallery
        items={images}
        defaultImage={slider1}
        showFullscreenButton={false}
        isRTL={false}
        showPlayButton={false}
        showThumbnails={false}
        renderRightNav={RightArrow}
        renderLeftNav={LeftArrow} />

    </>
  )
}

export default ProductGallery
